export default {
  heading: {
    padding: '40px',
    fontSize: '32px',
    lineHeight: '37px',
    fontWeight: 'bold',
    color: '#282424',

    '@media screen and (max-width: 600px)': {
      justifyContent: 'left',
      padding: '40px 20px',
      fontSize: '24px',
      lineHeight: '28px',
    },
  },
  textContainer: {
    '@media screen and (max-width: 600px)': {
      padding: '0 20px',
    },
  },
  textHeading: {
    marginBottom: '24px',
    fontSize: '24px',
    lineHeight: '28px',
    fontWeight: 'bold',
    color: '#100081',

    '@media screen and (max-width: 960px)': {
      fontSize: '20px',
      lineHeight: '23px',
    },

    '@media screen and (max-width: 600px)': {
      fontSize: '19px',
      lineHeight: '23px',
    },
  },
  text: {
    marginBottom: '70px',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 'normal',
    color: '#333333',

    '@media screen and (max-width: 960px)': {
      marginBottom: '40px',
    },

    '@media screen and (max-width: 600px)': {
      fontSize: '16px',
      lineHeight: '19px',
    },
  },
  image: {
    width: '100%',
  },
};
